import React from 'react';
import { FileText, BarChart3, TrendingUp, Calendar, Clock, AlertCircle } from 'lucide-react';

const ReportsPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
        <p className="text-gray-600">Analytics and reporting dashboard</p>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
        <div className="flex items-start gap-4">
          <AlertCircle className="h-6 w-6 text-yellow-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-yellow-900 mb-2">Coming Soon</h2>
            <p className="text-yellow-800 mb-4">
              The Reports module is currently under development. Soon you'll be able to:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <BarChart3 className="h-5 w-5 text-yellow-700" />
                  <h3 className="font-medium text-yellow-900">Analytics Dashboard</h3>
                </div>
                <p className="text-sm text-yellow-700">
                  View comprehensive analytics with charts, graphs, and key performance indicators
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <FileText className="h-5 w-5 text-yellow-700" />
                  <h3 className="font-medium text-yellow-900">Custom Reports</h3>
                </div>
                <p className="text-sm text-yellow-700">
                  Generate custom reports based on your specific business needs and criteria
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <Calendar className="h-5 w-5 text-yellow-700" />
                  <h3 className="font-medium text-yellow-900">Scheduled Reports</h3>
                </div>
                <p className="text-sm text-yellow-700">
                  Set up automated reports to be generated and delivered on a schedule
                </p>
              </div>

              <div className="bg-white bg-opacity-60 rounded-lg p-4">
                <div className="flex items-center gap-3 mb-2">
                  <TrendingUp className="h-5 w-5 text-yellow-700" />
                  <h3 className="font-medium text-yellow-900">Trend Analysis</h3>
                </div>
                <p className="text-sm text-yellow-700">
                  Analyze trends over time to make data-driven business decisions
                </p>
              </div>
            </div>

            <div className="mt-6 flex items-center gap-2 text-sm text-yellow-700">
              <Clock className="h-4 w-4" />
              <span>Expected release: Q2 2024</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsPage;